// extracted by mini-css-extract-plugin
export var activityContainer = "_nz-0";
export var typingIndicatorContainer = "_nz-1";
export var typingIndicatorDot = "_nz-2";
export var wave = "_nz-3";